import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { DataFilterModule, DataSortModule } from '@anecdotes/design-system/data-manipulation';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { ModalsModule } from '@anecdotes/design-system/modals';
import { MultiselectModule } from '@anecdotes/design-system/multiselect';
import { PipesModule } from '@anecdotes/design-system/pipes';
import { RenderingModule } from '@anecdotes/design-system/rendering';
import { TipsModule } from '@anecdotes/design-system/tips';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { SharedPolicyModule } from '@anecdotes/shared-policy';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicFormModule } from '@anecdotes/dynamic-form';
import { CoreModule } from 'core';
import { AccountFeaturesModule } from '@anecdotes/account-features';
import { HeadersModule } from '@anecdotes/ui/headers';
import { ControlsSharedModule } from '@anecdotes/shared-controls';
import { SharedEvidenceModule } from '@anecdotes/shared-evidence';
import { PluginsUiModule } from '@anecdotes/plugins-ui';
import { TrustCenterModalService } from '../../services';
import {
  ConfigMissingModalComponent,
  ControlEditSidePanelComponent,
  ControlSidePanelComponent,
  ControlSummaryComponent,
  ControlsComponent,
  DocumentCreateSidePanelComponent,
  DocumentEditSidePanelComponent,
  DocumentSidePanelComponent,
  DocumentsComponent,
  DownloadOrRequestAccessButtonComponent,
  EvidenceCollectionMenuButtonComponent,
  EvidenceDownloadSummaryComponent,
  FrameworkEditSidePanelComponent,
  FrameworkSummaryComponent,
  FrameworkSummaryEditComponent,
  FrameworksComponent,
  FrameworksEditSidePanelComponent,
  FrameworksSidePanelComponent,
  OverviewComponent,
  OverviewEditSidePanelComponent,
  PoliciesComponent,
  PolicyEditSidePanelComponent,
  PolicySidePanelComponent,
  PreviewComponent,
  PublishConfirmModalComponent,
  PublishedAlertComponent,
  RequestAccessModalComponent,
  RequestSentModalComponent,
  RequirementEditComponent,
  SubprocessorEditSidePanelComponent,
  SubprocessorsComponent,
  RequestAccessEmailModalComponent,
  PreviewLinkCustomerComponent,
  LastPublishedInfoComponent,
  MissingPermissionModalComponent,
  CustomSubprocessorSidePanelComponent,
  EvidenceSummaryComponent,
  FaqsComponent,
  FaqComponent,
  FaqSidePanelComponent,
  MonitoredLabelComponent,
  ControlsLabelComponent,
} from './components';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { setFavicon } from './utils';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GridDragDropModule } from '@anecdotes/design-system/drag-drop';
import { SharedTrustCenterModule, isStandaloneRef } from '@anecdotes/shared-trust-center';

@NgModule({
  declarations: [
    OverviewEditSidePanelComponent,
    FrameworkEditSidePanelComponent,
    DocumentEditSidePanelComponent,
    DocumentCreateSidePanelComponent,
    FrameworkSummaryComponent,
    FrameworkSummaryEditComponent,
    FrameworksSidePanelComponent,
    FrameworksEditSidePanelComponent,
    ControlSidePanelComponent,
    DocumentSidePanelComponent,
    ControlEditSidePanelComponent,
    RequirementEditComponent,
    SubprocessorEditSidePanelComponent,
    OverviewComponent,
    FrameworksComponent,
    DocumentsComponent,
    ControlsComponent,
    SubprocessorsComponent,
    ControlSummaryComponent,
    PreviewComponent,
    EvidenceCollectionMenuButtonComponent,
    RequestSentModalComponent,
    RequestAccessModalComponent,
    PublishConfirmModalComponent,
    EvidenceDownloadSummaryComponent,
    PublishedAlertComponent,
    PoliciesComponent,
    PolicyEditSidePanelComponent,
    DownloadOrRequestAccessButtonComponent,
    PolicySidePanelComponent,
    ConfigMissingModalComponent,
    RequestAccessEmailModalComponent,
    PreviewLinkCustomerComponent,
    LastPublishedInfoComponent,
    MissingPermissionModalComponent,
    CustomSubprocessorSidePanelComponent,
    EvidenceSummaryComponent,
    FaqsComponent,
    FaqComponent,
    FaqSidePanelComponent,
    MonitoredLabelComponent,
    ControlsLabelComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    TranslateModule.forChild(),
    HeadersModule,
    DataFilterModule,
    UtilsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatButtonModule,
    ReactiveFormsModule,
    DynamicFormModule,
    ControlsSharedModule,
    SharedEvidenceModule,
    ModalsModule,
    NgbTooltipModule,
    PluginsUiModule,
    AccountFeaturesModule,
    VirtualScrollerModule,
    ButtonsModule,
    MultiselectModule,
    TipsModule,
    SharedPolicyModule,
    DataSortModule,
    RenderingModule,
    DirectivesModule,
    PipesModule,
    DropdownMenuModule,
    SvgIconsModule,
    SharedTrustCenterModule,
    DragDropModule,
    GridDragDropModule,
  ],
  exports: [
    OverviewEditSidePanelComponent,
    FrameworkEditSidePanelComponent,
    DocumentEditSidePanelComponent,
    DocumentCreateSidePanelComponent,
    OverviewComponent,
    PreviewComponent,
    FrameworkSummaryComponent,
    FrameworkSummaryEditComponent,
    FrameworksSidePanelComponent,
    FrameworksEditSidePanelComponent,
    ControlSidePanelComponent,
    DocumentSidePanelComponent,
    ControlEditSidePanelComponent,
    RequirementEditComponent,
    SubprocessorEditSidePanelComponent,
    FrameworksComponent,
    DocumentsComponent,
    ControlSummaryComponent,
    ControlsComponent,
    SubprocessorsComponent,
    EvidenceCollectionMenuButtonComponent,
    RequestSentModalComponent,
    RequestAccessModalComponent,
    PublishConfirmModalComponent,
    EvidenceDownloadSummaryComponent,
    PublishedAlertComponent,
    PoliciesComponent,
    PolicyEditSidePanelComponent,
    DownloadOrRequestAccessButtonComponent,
    PolicySidePanelComponent,
    ConfigMissingModalComponent,
    RequestAccessEmailModalComponent,
    MissingPermissionModalComponent,
    CustomSubprocessorSidePanelComponent,
  ],
  providers: [TrustCenterModalService],
})
export class PreviewModule {
  constructor() {
    /* Setting the favicon for a published trust center */
    if (isStandaloneRef.isStandalone) {
      setFavicon();
    }
  }
}
